export default __webpack_public_path__ + "images/V7.e2d2d09.png";